import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from '../i18n';

interface Props {
  orderId: number;
}

export const HandoverWaitingBlock: React.FC<Props> = ({ orderId }) => {
  const { t } = useTranslation();
  const orderUrl = `${window.location.origin}/orders/${orderId}`;

  return (
    <div
      className="handover-waiting"
      role="status"
      aria-label={t('reports.waiting_confirm')}
    >
      <div className="waiting-indicator" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <p className="handover-waiting-message">{t('reports.waiting_confirm_phone')}</p>
      <QRCodeSVG value={orderUrl} size={132} marginSize={2} />
      <p className="text-muted handover-waiting-hint">{t('reports.scan_qr')}</p>
      <p className="text-muted handover-waiting-url">{orderUrl}</p>
    </div>
  );
};
